import { Injectable, inject } from "@angular/core";
import { filterNilValue } from "@datorama/akita";
import { isPropertyDefined } from "@recursyve/nice-ts-utils";
import { NiceNavigationService } from "@recursyve/nice-ui-kit.v2";
import { AccountRoles, isAccountRole } from "../api/accounts/enums/account-roles.enum";
import { AppQuery } from "../store/app.query";
import { adminNavigation } from "./admin.navigation";
import { distributorNavigation } from "./distributor.navigation";
import { organisationNavigation } from "./organisation.navigation";
import { supplierNavigation } from "./supplier.navigation";

@Injectable({
    providedIn: "root"
})
export class NavigationService {
    private readonly appQuery = inject(AppQuery);
    private readonly niceNavigationService = inject(NiceNavigationService);

    public init(): void {
        this.niceNavigationService.storeNavigation(AccountRoles.ADMIN, adminNavigation);
        this.niceNavigationService.storeNavigation(AccountRoles.DISTRIBUTOR, distributorNavigation);
        this.niceNavigationService.storeNavigation(AccountRoles.ORGANISATION, organisationNavigation);
        this.niceNavigationService.storeNavigation(AccountRoles.SUPPLIER, supplierNavigation);

        this.appQuery
            .selectCurrentAccount()
            .pipe(filterNilValue())
            .subscribe((account) => {
                if (!isPropertyDefined(account, "role")) {
                    this.niceNavigationService.setCurrentNavigation("");
                    return;
                }

                if (!isAccountRole(account.role)) {
                    this.niceNavigationService.setCurrentNavigation("");
                    return;
                }

                this.niceNavigationService.setCurrentNavigation(account.role);
            });
    }
}
